import { render } from "./LbrxOrdersSideBar.vue?vue&type=template&id=038e749a"
import script from "./LbrxOrdersSideBar.vue?vue&type=script&lang=js"
export * from "./LbrxOrdersSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__